module.exports = __webpack_public_path__ + "img/bg_five.1fa309ec.jpg";